import { DialogManager } from "@lib/titan2/dist/game/manager/DialogManager";
/**
 * GameDialogManager.ts
 */
export class GameDialogManager extends DialogManager {
}
//# sourceMappingURL=GameDialogManager.js.map